export default function getAlbumSource(track) {
  if (track.previewUrl) {
    return track.previewUrl;
  }
  var albumNumber = track.album.number || track.album.id;
  var trackNumber = track.albumTrackNumber;
  return "https://content2.audionetwork.com/Preview/tracks/mp3/v5res/ANW".concat(albumNumber, "/").concat(trackNumber.toString().padStart(2, 0), ".mp3");
}